import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/viva-classes.css";
import "./styles/video-js.css";

import jQuery from "jquery";
const $ = (window.$ = window.jQuery = jQuery);

import Vue from 'vue'
import App from './App.vue'
import router from "./router";

// Skip Bootstrap JS for now - just use CSS for styling

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Viva'
  next()
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')